import { AnimatingLogo } from '@eazydraft/ui';
import { useTranslation } from 'react-i18next';

import lucioLogoDark from '@/assets/icons/LucioLogoDark.svg';
import lucioLogoLight from '@/assets/icons/LucioLogoLight.svg';
import { useThemeStore } from '@/utils/stores/useThemeStore';

interface GreetingProps {
  userName?: string | null;
}

export function Greeting({ userName }: GreetingProps) {
  const { t } = useTranslation();
  // Asset swap instead of the icon-themed filter: AnimatingLogo's entrance
  // keyframes animate `filter`, which would suppress an invert during the
  // spin and make the logo flash dark before turning light.
  const theme = useThemeStore((state) => state.theme);
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="mb-2 flex h-12 w-12 items-center justify-center">
        <AnimatingLogo
          alt="Lucio"
          className="h-[48px] w-[48px]"
          src={theme === 'dark' ? lucioLogoLight : lucioLogoDark}
        />
      </div>
      <p className="text-tertiary m-0 p-0 text-center font-['Cormorant_Garamond'] text-[24px] leading-[160%] font-bold tracking-normal capitalize">
        {userName
          ? t('assistant.greeting.hi', { name: userName })
          : t('assistant.greeting.hiFallback')}
      </p>
      <p className="text-foreground font-serif text-lg font-bold">
        {t('assistant.greeting.whatsYourMove')}
      </p>
    </div>
  );
}
